/**
 * Playwright Generator Utilities
 *
 * Common utility functions used across the playwright generator modules.
 */

// ============================================================================
// String Utilities
// ============================================================================

/**
 * Escape special characters in strings for use in generated code
 * Note: Curly quotes (" " ' ') are NOT escaped - they're valid Unicode
 * characters that need to match the actual DOM content
 */
export function escapeString(str: string): string {
  return str
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"') // Only escape straight double quotes (string delimiter)
    .replace(/\n/g, "\\n")
    .replace(/\r/g, "\\r")
    .replace(/\t/g, "\\t");
}

// ============================================================================
// URL Utilities
// ============================================================================

/**
 * Get stateId from URL for use as filename
 * This is the canonical session ID that correlates with localStorage entries
 */
export function getStateIdFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  return new URL(window.location.href).searchParams.get("stateId");
}
